import type { NotificationWithHTTPStatusCode } from "common/utils/fetchHelpers";
import { handleFetchError } from "common/utils/fetchHelpers";
import { getOptionCatalogsMigrationURL } from "lib/endpointHelpers";
import { postWithTimeout } from "lib/utils/fetchAuthHelpers";

export async function migrateStudioDocOptions(params: {
  builderId: string;
  studioDocId: string;
}): Promise<NotificationWithHTTPStatusCode | null> {
  try {
    const res = await postWithTimeout(
      `${getOptionCatalogsMigrationURL(params.builderId)}/migrate-options?studioDocId=${params.studioDocId}`,
      undefined,
      30 * 1000,
    );

    if (!res.ok) {
      throw res;
    }

    return null;
  } catch (e) {
    return await handleFetchError(e);
  }
}
